// extracted by mini-css-extract-plugin
export default {"PostAJobBanner":"styles_PostAJobBanner__Ivw7e","left":"styles_left__3jwL8"};